/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RoleInputModel } from '../../models/role-input-model';
import { RoleModel } from '../../models/role-model';

export interface PutApiRoleV1Id$Json$Params {
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: RoleInputModel
}

export function putApiRoleV1Id$Json(http: HttpClient, rootUrl: string, params: PutApiRoleV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<RoleModel>> {
  const rb = new RequestBuilder(rootUrl, putApiRoleV1Id$Json.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RoleModel>;
    })
  );
}

putApiRoleV1Id$Json.PATH = '/private/v1/roles/{id}';
